import { SpellBookView } from '@/components/game/SpellBook';

export function SpellsPage() {
  return <SpellBookView />;
}
